import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesTestXinkeView {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if(webcontext.ID){
            webcontext.RequestBody=JSON.stringify({"a_FK_TBCeShiXinKeLieBiao_ID":webcontext.ID});
        }
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext){
        return webContext;
    }
}